import { SpacerBlockProps } from "./SpacerBlock.types";

export const SpacerDefaultHeight = 24;
export const SpacerMinHeight = 4;
export const SpacerMaxHeight = 200;

/** Deliberate vertical space. Hidden from assistive technology - it's whitespace. */
export function SpacerBlock({
  height = SpacerDefaultHeight,
  className = "",
}: SpacerBlockProps) {
  return (
    <div
      aria-hidden="true"
      className={className}
      style={{ height: `${height}px` }}
    />
  );
}

export default SpacerBlock;
